<template>
  <div class="router-header flex flex-wrap items-center">
    <div class="content-area__heading">
      <p class="font">{{ $t("labels.transaction") }}</p>
    </div>
    <div class="ml-auto md:block">
      <vs-button
        color="success"
        icon="icon-search"
        @click="data_hide = !data_hide"
        icon-pack="feather"
        >Search</vs-button
      >
    </div>
    <vx-card class="mt-4" v-show="data_hide">
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/4 w-full">
          <vs-input
            class="w-full"
            icon-pack="feather"
            :placeholder="$t('labels.transaction_id')"
            icon-no-border
            :label="$t('labels.transaction_id')"
            v-model="tran_id"
            id="text-box-val-city"
            @keyup.delete="getAllTransactions()"
          />
        </div>
        <div class="vx-col sm:w-1/4 w-full">
          <label class="vs-input--label">{{
            $t("labels.transaction_typee")
          }}</label>
          <v-select
            v-validate="'required'"
            :placeholder="$t('labels.select_tran_type')"
            name="subcategory_type"
            v-model="mode"
            :success="true"
            :clearable="false"
            success-text="This field is valid"
            :options="categoryArray"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            class="w-full"
            label="value"
          />
        </div>
        <div class="vx-col sm:w-1/4 w-full">
          <label class="vs-input--label">{{
            $t("labels.transaction_status")
          }}</label>
          <v-select
            v-validate="'required'"
            :placeholder="$t('labels.select_tran_status')"
            name="subcategory_type"
            v-model="pay_status"
            :success="true"
            :clearable="false"
            success-text="This field is valid"
            :options="statusArray"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            class="w-full"
            label="value"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button
            color="success"
            class="mr-3 mb-2"
            @click="getAllTransactions()"
            >Search</vs-button
          >
          <vs-button color="danger" class="mb-2 mr-3" @click="resetForm()"
            >Reset</vs-button
          >
          <vs-button color="black" class="mb-2" @click="closeForm()"
            >Close</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card class="mt-4">
      <vs-table :max-items="perPage" stripe :data="orders">
        <template slot="thead">
          <vs-th>{{ $t("labels.transaction_id") }}</vs-th>
          <vs-th>{{ $t("labels.transaction_type") }}</vs-th>
          <vs-th>{{ $t("labels.transaction_amount") }}</vs-th>
          <vs-th>{{ $t("labels.user_name") }}</vs-th>
          <vs-th>{{ $t("labels.class_title") }}</vs-th>
          <vs-th>{{ $t("labels.transaction_time") }}</vs-th>
          <vs-th>{{ $t("labels.status") }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].id">
              {{ data[indextr].id }}
            </vs-td>

            <vs-td :data="data[indextr].transaction_type">
              {{ data[indextr].transaction_type }}
            </vs-td>

            <vs-td :data="data[indextr].total_amount">
              <p
                v-if="data[indextr].transaction_type == 'Pay in'"
                style="color: green"
              >
                {{ data[indextr].total_amount }}
              </p>
              <p
                v-if="data[indextr].transaction_type == 'Refund'"
                style="color: red"
              >
                {{ data[indextr].total_amount }}
              </p>
              <p
                v-if="data[indextr].transaction_type == 'refund'"
                style="color: red"
              >
                {{ data[indextr].total_amount }}
              </p>
            </vs-td>

            <vs-td class="word-break" :data="data[indextr].user_detail.name">
              {{ data[indextr].user_detail.name | upper }}
            </vs-td>

            <vs-td :data="data[indextr].listing_detail.title">
              {{ data[indextr].listing_detail.title | upper }}
            </vs-td>
            <vs-td :data="data[indextr].created_at">
              {{ data[indextr].created_at | formatDateTime }}
            </vs-td>
            <vs-td :data="data[indextr].payment_status">
              <p
                v-if="data[indextr].payment_status == 'pending'"
                style="color: red"
              >
                {{ data[indextr].payment_status | upper }}
              </p>
              <p
                v-if="data[indextr].payment_status == 'success'"
                style="color: green"
              >
                {{ data[indextr].payment_status | upper }}
              </p>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <div class="float-right mt-5">
      <vs-pagination
        ref="paginationApplication"
        :total="totalPage"
        v-model="currentPage"
      ></vs-pagination>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
export default {
  components: {
    "v-select": vSelect,
  },
  data: () => ({
    value: "",
    select2: "",
    data_hide: false,
    orders: [],
    mode: "",
    pay_status: "",
    tran_id: "",
    state: "",
    changeID: null,
    deleteID: null,
    page: 1,
    perPage: 10,
    totalPage: 0,
    currentPage: 1,
    pay_status_search: "",
    mode_search: "",
    categoryArray: [
      {
        id: "Pay in",
        value: "Pay in",
      },
      {
        id: "Refund",
        value: "Refund",
      },
    ],
    statusArray: [
      {
        id: "success",
        value: "Success",
      },
      {
        id: "pending",
        value: "Pending",
      },
      {
        id: "failed",
        value: "Failed",
      },
    ],
  }),
  watch: {
    currentPage(nv) {
      if (nv) {
        // this.$route.query.page = nv;
        this.getAllTransactions();
      }
    },
    perPage(nv) {
      if (nv) {
        this.getAllTransactions();
      }
    },
    search(nv) {
      if (!nv) {
        this.perPage = 10;
        this.currentPage = 1;
        if (this.$refs.paginationApplication) {
          this.$refs.paginationApplication.current = 1;
        }
        this.getAllTransactions();
      }
    },
  },
  methods: {
    getAllTransactions() {
      if (this.pay_status) {
        this.pay_status_search = this.pay_status.id;
      } else {
        this.pay_status_search = "";
      }
      if (this.mode) {
        this.mode_search = this.mode.id;
      } else {
        this.mode_search = "";
      }
      let input = {
        mode: this.mode_search,
        pay_status: this.pay_status_search,
        tran_id: this.tran_id,
        page: this.currentPage,
        perPage: this.perPage,
      };
      console.log(input);
      axios
        .post("admin/allTransaction", input)

        .then((response) => {
          let data = response.data.data;
          this.orders = data.order;
          console.log(data);
          if (data.count < this.perPage) {
            this.currentPage = 1;
          }
          this.totalPage = Math.ceil(data.count / this.perPage);
        })
        .catch((e) => {
          this.showError(e);
        });
    },
    resetForm() {
      (this.mode = ""),
        (this.pay_status = ""),
        (this.tran_id = ""),
        this.getAllTransactions();
    },
    closeForm() {
      this.data_hide = !this.data_hide;
    },
    ClassDetails(id) {
      this.$router.push({ name: "ClassById", params: { id: id } });
    },
  },
  mounted() {
    this.getAllTransactions();
  },
};
</script>

<style lang="scss" scoped>
</style>